import { Route, Routes } from 'react-router-dom';

import { SpacePageType } from '../constants/spacePageType';
import AIMemoryBoostScreen from '../screens/Album/AIMemoryBoost';
import AIMemoryBoostGameListScreen from '../screens/Album/AIMemoryBoostGameList';
import AlbumPathListScreen from '../screens/Album/AlbumPathList';
import ClubsRecentAlbumList from '../screens/Album/ClubsRecentAlbumList';
import RecentAlbumListScreen from '../screens/Album/RecentAlbumList';
import NotFound from '../screens/Auth/NotFound';
import ClubListScreen from '../screens/Clubs/ClubListScreen';
import ClubScreen from '../screens/Clubs/ClubScreen';
import HomeClubScreen from '../screens/Clubs/HomeClubScreen';
import Game from '../screens/Game/Game';
import GameAnalysisScreen from '../screens/Game/GameAnalysisScreen';
import GameMemoryHelperScreen from '../screens/Game/GameMemoryHelper';
import GamePreviewScreen from '../screens/Game/GamePreviewScreen';
import PerformanceReportGameList from '../screens/PerformanceReport/PerformanceReportGameList';
import PerformanceReportScreenV2 from '../screens/PerformanceReport/PerformanceReportV2';

const SpaceRoute: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/hot"
        element={<ClubListScreen spacePageType={SpacePageType.Hot} />}
      />
      <Route
        path="/recent"
        element={<ClubListScreen spacePageType={SpacePageType.Recent} />}
      />
      <Route path="/journey" element={<HomeClubScreen />} />
      <Route path="/:classroomId" element={<ClubScreen />} />
      <Route
        path="/:classroomId/performance-report"
        element={<PerformanceReportScreenV2 />}
      />
      <Route
        path="/:classroomId/performance-report/games"
        element={<PerformanceReportGameList />}
      />
      <Route
        path="/:classroomId/memory-boost"
        element={<AIMemoryBoostScreen />}
      />
      <Route
        path="/:classroomId/memory-boost/:aiRevisionStatus"
        element={<AIMemoryBoostGameListScreen />}
      />
      <Route
        path="/:classroomId/journey-recent"
        element={<RecentAlbumListScreen />}
      />
      <Route
        path="/journey-recent/hot"
        element={<ClubsRecentAlbumList spacePageType={SpacePageType.Hot} />}
        // if later have more spacePageType, make this to be general case
      />
      <Route
        path="/journey-recent/recent"
        element={<ClubsRecentAlbumList spacePageType={SpacePageType.Recent} />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId"
        element={<AlbumPathListScreen />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/memory-boost"
        element={<AIMemoryBoostScreen />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/memory-boost/:aiRevisionStatus"
        element={<AIMemoryBoostGameListScreen />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/game/:gameId/analysis"
        element={<GameAnalysisScreen />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/game/:gameId/helper"
        element={<GameMemoryHelperScreen />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/game/:gameId"
        element={<Game />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/challenge/:challengeIndex"
        element={<Game />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/game/:gameId/share"
        element={<GamePreviewScreen />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/challenge/:pathChallengeIndex/share"
        element={<GamePreviewScreen />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/challenge/super/share"
        element={<GamePreviewScreen />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default SpaceRoute;
